import { ValidationStateMessage } from './ValidationStateMessage';

/**
 * FormControlValidationState
 *
 * - Not to be confused with JavaScript native ValidityState
 * - to be returned from ValidatorFunction Promise<FormControlValidationState>
 * - will be this.validationState in inline-validator
 */
export class FormControlValidationState implements ValidationStateMessage {
  /**
   * Boolean if the form input is valid.
   * Can be null - which means neither success nor error state is indicated on the input
   *
   * @see  ValidationStateMessage.isValid
   */
  isValid: boolean;

  /**
   * In order of precedence
   * - ValidatorFunction.message
   * - successMessage
   * - errorMessage
   *
   * @see ValidationStateMessage.message
   */
  message: string;

  /**
   * ValidationStateMessage constructor()
   * Class properties set from args
   *
   * @param ValidationStateMessage
   */
  constructor(args: ValidationStateMessage = {}) {
    const { isValid, message } = args;
    this.isValid = isValid;
    this.message = message;
  }
}
